import React, { useEffect, useState } from 'react';
import { useTitle } from '../contexts/TitleContext';
import { Box, Tab, Tabs } from '@mui/material';
import CustomTabPanel from '../components/CustomTabPanel/CustomTabPanel';
import BidManagementDataGrid from '../components/BidManagementDataGrid/BidManagementDataGrid';

const BidManagementTool: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);
  const { setTitle } = useTitle();
  useEffect(() => {
    setTitle(`Bid Management Tool`);
  }, [setTitle]);

  const handleChangeTab = (_: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box display="flex" flexDirection="column" width="100%" maxWidth="82vw">
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          marginTop: '15px',
        }}
      >
        <Tabs value={tabValue} onChange={handleChangeTab} centered>
          <Tab label="Google Ads" id="tab-1" aria-controls="tab-1" value={0} />
          <Box
            sx={{
              alignSelf: 'center',
              borderLeft: 1,
              borderWidth: 2,
              borderColor: 'divider',
              height: '32px',
            }}
          />
          <Tab
            label="Microsoft Ads"
            id="tab-2"
            aria-controls="tab-2"
            value={1}
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={tabValue} index={0}>
        <BidManagementDataGrid reportType={'google-ads'} />
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={1}>
        <BidManagementDataGrid reportType={'microsoft-ads'} />
      </CustomTabPanel>
    </Box>
  );
};

export default BidManagementTool;
